import {FormAction, VisaFN, VisaFormConfig, VisaFormName} from 'src/app/shared/models/forms';
import { UserPlatformRole } from '../user';

//Model to represent the passport form config
export const PASS_FORM_CONFIG: VisaFormConfig = {
  [VisaFormName.PERSONAL_DETAILS]: {
    version: 0.1,
    classNames: 'gap_25',
    fields: [
      {name: VisaFN.REGISTRATION_PORT_ID, type: 'select', icon: 'globe', validators: [], showInResume: true},
      {name: VisaFN.LAST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.FIRST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.BIRTH_DAY, type: 'date', icon: 'cake-candles', validators: [], showInResume: true},
      {name: VisaFN.REQUEST_REASON, type: 'select', hidden: true, alwaysVisible: false, showInResume: false}
    ]
  },
  [VisaFormName.MISCELLANEOUS_DETAILS]: {
    version: 0.1,
    classNames: 'gap_25',
    toBeRemoved: true,
    fields: [
      {name: VisaFN.PASSPORT_TYPE, type: 'select', icon: 'passport', validators: [], showInResume: true},
      {name: VisaFN.PREVIOUS_PASSPORT_NUMBER, type: 'text', icon: 'passport', validators: [], showInResume: true},
      {name: VisaFN.NNI, type: 'text', icon: 'id-card', validators: [], showInResume: true}
    ]
  },
  [VisaFormName.DOCUMENT]: {
    version: 0.1,
    classNames: 'gap_10',
    disabledForSeniorities: [1],
    disabledForRoles: [UserPlatformRole.CUSTOMER, UserPlatformRole.WORKER],
    fields: [
      {name: VisaFN.ID_CARD_SCAN, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.PASSPORT_SCAN, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.APPLICATION_FORM, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.AUTHORIZATION_FORM, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.APPROVED_MISSION_ORDER, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.IDENTIFICATION_SHEET, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.LOSS_DECLARATION, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.IDENTITY_PHOTO, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE},
      {name: VisaFN.FORM_DEMAND, type: 'scanDoc', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1400 * 1000, action: FormAction.UPLOAD_FILE}
    ]
  }
};
